module.exports = __webpack_public_path__ + "8bb5451aa24a099d5798662b54961236.woff";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/fonts/JohnDeereSans-Medium.woff
// module id = 1642
// module chunks = 0